import { observer } from "mobx-react";
import * as React from "react";
import { InputHierarchy } from "../DocumentManagement";
import { DocumentStoreImpl } from "../Stores/DocumentStore";

export interface IInputHierarchyComponentProps {
	model: InputHierarchy;
	documentStore: DocumentStoreImpl;
	onChange?: () => void;
	testId?: string;
}

@observer
export class InputHierarchyComponent extends React.Component<IInputHierarchyComponentProps, {}> {

	onClick = () => {
		this.props.documentStore.hierarchyMetaValueWizardStore.open();
	}

	handleChange = () => {
		this.props.model.isValid = true;
		this.props.model.validationMessage = null;
		if (this.props.onChange) {
			this.props.onChange();
		}
		this.forceUpdate();
	}

	render() {
		return <label className="required" title="">
			<input type="text" onClick={this.onClick} onChange={this.handleChange} value={this.props.model.value} data-test-id={this.props.testId} className={!this.props.model.isValid ? "is--input-invalid" : null} />
			{this.props.model.validationMessage ? <span>{this.props.model.validationMessage}</span> : null}
		</label>;
	}
}

